import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithHandlingUnauthorized } from '@ui/src';

const api = createApi({
  reducerPath: 'transactionsApi',
  baseQuery: baseQueryWithHandlingUnauthorized(process.env.API_HOST as string),
  tagTypes: ['Transactions'],
  endpoints: () => ({}),
});

export default api;
